import { createSlice } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { getActionsPermissions } from "../../../services/actions";

export const PERMISSIONS_REDUCER_KEY = "permissions";

const initialState = {
  serverActions: [],
  tenancy: "",
};

const permissionsSlice = createSlice({
  name: PERMISSIONS_REDUCER_KEY,
  initialState,
  reducers: {
    setServerActions: (state, { payload }) => {
      state.serverActions = payload ?? [];
    },
    setTenancy: (state, { payload }) => {
      state.tenancy = payload ?? "";
    },
  },
});

export const { setServerActions, setTenancy } = permissionsSlice.actions;
export default permissionsSlice.reducer;

export const useServerActions = () =>
  useSelector((state) => state[PERMISSIONS_REDUCER_KEY].serverActions);

export const useTenancy = () =>
  useSelector((state) => state[PERMISSIONS_REDUCER_KEY].tenancy);

export const useRefetchServerActions = () => {
  const dispatch = useDispatch();
  return async () => {
    const res = await getActionsPermissions();
    dispatch(setServerActions(res));
  };
};
